import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
  FormControl,
  Toolbar,
  Typography,
  Select,
  InputBase,
  MenuItem,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import PropTypes from "prop-types";
import classNames from "classnames";

import { toolbarStyles } from "./style";
import PickerMonth from "../../partials/pickerMonth";

// Style
class EnhancedTableToolbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: "",
      to: moment().valueOf(),
      from: moment().subtract(3, "months"),
      branchCode: "",
    };
    this.typeEmotion = ["angry", "sad", "normal", "happy", "love"];
    this.handleChangeDate = this.handleChangeDate.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  convertDate = (date) => {
    return moment(date).format("MM/YYYY");
  };
  renderMonth = (props, month, year, selectedDate) => {
    return <td {...props}>{month + 1}</td>;
  };
  handleChangeDate(value, name) {
    const _this = this;
    this.setState({ [name]: value }, function () {
      _this.props.changeEmotion({
        from: _this.state.from,
        to: _this.state.to,
        branchCode: _this.state.branchCode,
      });
    });
  }
  handleChange(event) {
    let _this = this;
    let value = event.target.value;
    this.setState({ [event.target.name]: value }, function () {
      _this.props.changeEmotion({
        from: _this.state.from,
        to: _this.state.to,
        branchCode: _this.state.branchCode,
      });
    });
  }
  render() {
    const { classes, t, listBranch } = this.props;
    const { from, to } = this.state;
    return (
      <Toolbar className={classes.root}>
        <div className={classes.title}>
          <Typography
            color="inherit"
            variant="h6"
            className={classes.titleText}
          >
            {t("nps_total")} {this.props.total} {t("nps_interact")}
          </Typography>
        </div>
        <div className={classes.actions}>
          <div className={classes.box}>
            <FormControl className={classes.formControl}>
              <Select
                value={this.state.branchCode}
                onChange={this.handleChange}
                input={
                  <InputBase
                    fullWidth
                    style={{ textTransform: "capitalize" }}
                    classes={{
                      root: classNames(
                        classes.inputRootSelected,
                        classes.inputRoot
                      ),
                      input: classNames(
                        classes.inputInputSelected,
                        classes.inputInput
                      ),
                    }}
                  />
                }
                displayEmpty
                classes={{
                  select: classes.selected,
                }}
                name="branchCode"
                className={classes.selectType}
              >
                <MenuItem key={"-1"} value="">
                  {t("select_branch_with_map_all_branch")}
                </MenuItem>
                {listBranch.map((branch, index) => (
                  <MenuItem
                    key={index}
                    value={branch.branchCode}
                    style={{ textTransform: "capitalize" }}
                  >
                    {branch.branchName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className={classes.box}>
            <Typography color="inherit" variant="body1">
              {t("dashboard_order_toolbar_from")}
            </Typography>
            <div className={classes.inputBase}>
              <PickerMonth
                handleChange={this.handleChangeDate}
                nameInput="from"
                time={from}
              />
            </div>
          </div>
          <div className={classes.box}>
            <Typography color="inherit" variant="body1">
              {t("dashboard_order_toolbar_to")}
            </Typography>
            <div className={classes.inputBase}>
              <PickerMonth
                handleChange={this.handleChangeDate}
                nameInput="to"
                time={to}
              />
            </div>
          </div>
        </div>
      </Toolbar>
    );
  }
}

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  listBranch: state.serviceBranch.listBranch,
});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(toolbarStyles)(EnhancedTableToolbar)));
